import React from "react";
import { Routes, Route } from "react-router-dom";
import * as routes from "../constants/routes";

import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";

import SourceSelect from "../pages/SourceSelect";
import ExcelImport from "../pages/ExcelImport";
import SignInContainer from "../containers/SignInContainer";
import DashboardContainer from "../containers/DashboardContainer";
import SettingsContainer from "../containers/SettingsContainer";
import ProjectsContainer from "../containers/ProjectsContainer";
import ToolContainer from "../containers/ToolContainer";
import Reports from "../pages/Reports";

import AdminStripe from "../components/Admin/AdminStripe";
import AdminSettings from "../components/Admin/AdminSettings";
import NotFound from "../components/NotFound";
import SubscriptionSettings from "../components/Subscription/SubscriptionSettings";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={routes.SOURCE_SELECT} element={<SourceSelect />} />
      <Route path={routes.EXCEL_IMPORT} element={<ExcelImport />} />
      <Route path={routes.LANDING} element={<DashboardContainer />} />
      <Route
        path={routes.SIGN_IN}
        element={<PublicRoute component={SignInContainer} />}
      />
      <Route
        path={routes.DASHBOARD}
        element={<PrivateRoute component={DashboardContainer} />}
      />
      <Route
        path={routes.ADMIN_STRIPE}
        element={<PrivateRoute component={AdminStripe} />}
      />
      <Route
        path={routes.ADMIN_SETTINGS}
        element={<PrivateRoute component={AdminSettings} />}
      />
      {/* <Route
        path={routes.STRIPE_SUBSCRIPTION}
        element={<PrivateRoute component={SubscriptionSettings} />}
      /> */}
      <Route
        path={routes.SETTINGS}
        element={<PrivateRoute component={SettingsContainer} />}
      />
      <Route
        path={routes.PROJECTS}
        element={<PrivateRoute component={ProjectsContainer} />}
      />
      <Route
        path={routes.BVATOOL}
        element={<PrivateRoute component={ToolContainer} />}
      />
      <Route
        path={routes.REPORTS}
        element={<PrivateRoute component={Reports} />}
      />

      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
